var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { patchStakeholder } from '@sonar-software/sonar-core';
import { PlaintextCellEditor } from '@ui/text/PlaintextCellEditor';
import { ErrorOrFailStatusCode, SuccessStatusCode } from '@sonar-software/sonar-http';
import { genericProcessingFailure, useProcessing, useStakeholderReference, useUpdateStakeholderReference } from '@hooks';
import { NOTIFICATIONS_COPY, STAKEHOLDER_EMAIL } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
const rules = [
    {
        message: STAKEHOLDER_EMAIL.VALIDATION_MESSAGE,
        pattern: STAKEHOLDER_EMAIL.PATTERN,
        required: false
    }
];
function updateEmail(stakeholderId, email) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield patchStakeholder({
            email,
            stakeholderId
        });
        if (result.status === ErrorOrFailStatusCode.Conflict) {
            return {
                message: NOTIFICATIONS_COPY.STAKEHOLDER_CONFLICT,
                success: false
            };
        }
        if (result.status !== SuccessStatusCode.NoContent) {
            return genericProcessingFailure;
        }
        return { success: true };
    });
}
export const StakeholderEmailCellEditor = ({ stakeholderId }) => {
    const { email } = useStakeholderReference(stakeholderId);
    const { reset, start, state, stop } = useProcessing();
    const update = useUpdateStakeholderReference();
    const handleSave = useCallback((newValue) => __awaiter(void 0, void 0, void 0, function* () {
        if (email === newValue) {
            return;
        }
        start();
        const updateResult = yield updateEmail(stakeholderId, newValue);
        if (updateResult.success) {
            update({
                email: newValue,
                stakeholderId
            });
        }
        stop(updateResult);
    }), [email, stakeholderId, start, stop, update]);
    return (React.createElement(PlaintextCellEditor, { isProcessing: state.isProcessing, onSave: handleSave, onStartEditing: reset, processingResult: state.result, rules: rules, skipSpellcheck: true, value: email }));
};
